import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField, NumberField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <TextField source="code" label={t('admin.code')}/>
            <TextField source="isBriefManyProducts" label={t('admin.isBriefManyProducts')}/>
        </ShowGuesser>
    )
}

export default Show
